export const Typographie = {
  fontFamily: "Montserrat, sans-serif;",
};